export const gifEncodeLockState = {
  queue: Promise.resolve(),
  depth: 0,
};
